// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardSummaryComponent } from './components/dashboard-summary/dashboard-summary.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { dashboardSummaryReducer, STATE_NAME } from './store/dashboard-summary.reducer';
import { DashboardSummaryEffects } from './store/dashboard-summary.effects';
import { BrandSummaryModule } from '@coa/app/shared/brand-summary/brand-summary.module';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardSummarySkeletonComponent } from './components/dashboar-summary-skeleton/dashboard-summary-skeleton.component';
import { BrandSummarySkeletonComponent } from '@coa/app/shared/brand-summary/skeleton/brand-summary-skeleton/brand-summary-skeleton.component';
import { RepeatElementModule } from '@coa/app/shared/repeat-element/repeat-element.module';
import { ListModule } from '@coa/app/shared/list/list.module';
import { ChartDataSeriesModule } from '@coa/app/shared/chart-data-series/chart-data-series.module';
import { LoadMoreModule } from '@coa/app/shared/load-more/load-more.module';


@NgModule({
  declarations: [
    DashboardSummaryComponent,
    DashboardSummarySkeletonComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(STATE_NAME, dashboardSummaryReducer),
    EffectsModule.forFeature([DashboardSummaryEffects]),
    BrandSummaryModule,
    TranslateModule,
    RepeatElementModule,
    ListModule,
    ChartDataSeriesModule,
    LoadMoreModule,
  ],
  exports: [
    DashboardSummaryComponent, BrandSummarySkeletonComponent,
  ],
})
export class DashboardSummaryModule {
}
